import axios from "axios";

const moduleMrp = {
  namespaced: true,
  state: {
    mrpList: [],
    mrpLength: 0,
  },
  mutations: {
    setMrpList(state, data) {
      state.mrpList = data;
    },
    setMrpLength(state, length) {
      state.mrpLength = length;
    },
  },
  actions: {
    async fetchMrpList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(`/api/mrp/${clinicUrl}/${branchUrl}`);
        const mrpList = res.data.data;
        const mrpLength = res.data.total;

        commit("setMrpList", mrpList);
        commit("setMrpLength", mrpLength);
        return { data: mrpList, total: mrpLength };
      } catch (err) {
        console.error("fetchMrpList failed", err);
        throw err;
      }
    },
    async fetchMrpById(_, { clinicUrl, branchUrl, id }) {
      try {
        const res = await axios.get(`/api/mrp/${clinicUrl}/${branchUrl}/${id}`);
        return res.data.data;
      } catch (err) {
        console.error("fetchMrpById failed", err);
        throw err;
      }
    },
  },
  getters: {
    getMrpList: state => {
      return state.mrpList;
    },
    getMrpLength: state => {
      return state.mrpLength;
    },
    isShowRedDot: state => {
      return state.mrpLength > 0;
    }
  },
};

export default moduleMrp;
